import { render, staticRenderFns } from "./ednSwitch.vue?vue&type=template&id=479693d3"
import script from "./ednSwitch.vue?vue&type=script&lang=js"
export * from "./ednSwitch.vue?vue&type=script&lang=js"
import style0 from "./ednSwitch.vue?vue&type=style&index=0&id=479693d3&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports